import { serverApi } from "./http";

export type SshAuthType = "PASSWORD" | "PRIVATE_KEY";

export interface SshProfile {
    id: number;
    name: string;
    sshHost: string;
    sshPort: number;
    sshUsername: string;
    sshAuthType: SshAuthType;
    sshPrivateKeyPath?: string;
    strictHostKeyChecking: boolean;
    hasStoredSshPassword?: boolean;
    linkedPathCount?: number;
    linkedSiteIds?: number[];
}

export type SshProfileSaveRequest = Omit<
    SshProfile,
    "id" | "hasStoredSshPassword" | "linkedPathCount" | "linkedSiteIds"
> & {
    id?: number;
    sshPassword?: string;
    saveSshPassword?: boolean;
};

export const getSshProfiles = async (): Promise<SshProfile[]> => {
    const response = await serverApi.get<SshProfile[]>("/api/ssh-profiles");
    return response.data;
};

export const saveSshProfile = async (
    profile: SshProfileSaveRequest
): Promise<SshProfile> => {
    if (profile.id == null) {
        const response = await serverApi.post<SshProfile>("/api/ssh-profiles", profile);
        return response.data;
    }
    const response = await serverApi.put<SshProfile>(
        `/api/ssh-profiles/${encodeURIComponent(profile.id)}`,
        profile
    );
    return response.data;
};

export const deleteSshProfile = async (profileId: number): Promise<void> => {
    await serverApi.delete(`/api/ssh-profiles/${encodeURIComponent(profileId)}`);
};

export const updateSshProfileSiteLinks = async (
    profileId: number,
    siteIds: number[]
): Promise<SshProfile> => {
    const response = await serverApi.put<SshProfile>(
        `/api/ssh-profiles/${encodeURIComponent(profileId)}/sites`,
        { siteIds }
    );
    return response.data;
};
